// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---dPL_Q","sk-bouncedelay":"sk-bouncedelay---J9ius","bounce1":"bounce1---NCwSS","bounce2":"bounce2---TC1Ah"};